

import styled, { css } from 'styled-components';
import { FlexBox } from '@brg/ui';
import { LayoutConst } from 'core/modules';

export const ProjectContainerLayoutLeftWrapper = styled(FlexBox)<{ isCompetitionEdit?: boolean, isAgeytomesh?: boolean, isProjectEdit?: boolean, isProjectPage?: boolean, isBooksPage?: boolean, isBookMainPage?: boolean, isBookEdit?: boolean }>`
    margin-right: 24px;
    height: max-content;
    @media (max-width: 940px) {
        flex-direction: column;
        width: 100%;
        min-height: 0;
        overflow: hidden;
        margin-top: 16px;
        //padding: 0 0 0 min(calc(940px - 100vw)/2 , 10px);
        padding: 0;
        ${({ isAgeytomesh}) => isAgeytomesh ? css`
            margin-top: 0;
        ` : null}
    }
    @media (max-width: 743px) {
        padding: 0 0 0 min(calc(940px - 100vw)/2 , 10px);
    }

    ${({ isProjectEdit, isProjectPage, isBookMainPage, isBookEdit, isCompetitionEdit}) => (isProjectEdit || isProjectPage || isBookMainPage || isBookEdit || isCompetitionEdit) ? css`
       @media(max-width: ${LayoutConst.screen.md}px) {
 /*           max-width: ${LayoutConst.projectCover.m.w}px;
            height: ${LayoutConst.projectCover.m.h}px;
            max-height: ${LayoutConst.projectCover.m.h}px;
            min-height: ${LayoutConst.projectCover.m.h}px;*/
            margin-top: ${isProjectPage ? '8px'  : 'inherit'};
            margin-right: ${isCompetitionEdit ? 0 : '16px'};
            min-width: calc(50vw - 24px);
            width: calc(50vw - 24px);
            max-width: calc(50vw - 24px);
            height: auto;
            min-height: auto;

            > div {
                max-height: calc((50vw - 24px) * 1.407);
            }
        }

        > div {
            @media(max-width: ${LayoutConst.screen.s-1}px) {
                max-height: 100%;
                height: 100%;
                min-height: 100%;
            }
        }
/*
        @media(max-width: 834px) {
            max-width: calc(50vw - 8px);
            height: ${LayoutConst.projectCover.s.h}px;
            max-height: ${LayoutConst.projectCover.s.h}px;
            min-height: ${LayoutConst.projectCover.s.h}px;
            margin-right: 16px;
            margin-top: ${isProjectPage ? '8px' : 'inherit'};
        }
*/

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            flex-direction: column;
            width: 100%;
            max-width: 100%;
            min-width: 100%;
            min-height: 0;
            height: ${isBookEdit ? 'calc((100vw - 10px) * 1.407)' : '100%'};
            max-height: calc((100vw - 10px ${isBookMainPage ? '+ 70px' : ''}) * 1.407);
            overflow: hidden;
            margin-top: ${isProjectEdit || isCompetitionEdit ? 'inherit' : '16px'};
            margin-left: 0;
            padding: 0 min(calc(940px - 100vw)/2 , 10px);
            //padding: 0;
        }
    ` : null};
  
`;
export const ProjectContainerLayoutRightWrapper = styled(FlexBox)<{ isCompetitionEdit?: boolean, isProjectEdit?: boolean, isProjectPage?: boolean, isBookMainPage?: boolean, isBookEdit?: boolean }>`
    width: 100%;

    ${({ isBookMainPage, isProjectPage, isProjectEdit, isCompetitionEdit}) => isCompetitionEdit || isBookMainPage || isProjectPage || isProjectEdit ? css`
        min-width: ${LayoutConst.projectCover.l.w}px;
        max-width: ${LayoutConst.projectCover.l.w}px;
    ` : null};
    

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        ${({ isBookMainPage, isProjectPage, isProjectEdit, isCompetitionEdit, isBookEdit }) => isCompetitionEdit || isBookMainPage || isProjectPage || isProjectEdit || isBookEdit? css`
        max-width: ${LayoutConst.projectCover.m.w}px;
        min-width: ${LayoutConst.projectCover.m.w}px;
    ` : null};
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        ${({ isBookMainPage, isProjectPage, isProjectEdit, isCompetitionEdit, isBookEdit }) => (isCompetitionEdit || isBookMainPage || isProjectPage || isProjectEdit || isBookEdit) ? css`
        min-width: ${LayoutConst.projectCover.m.w}px;
        max-width: ${LayoutConst.projectCover.m.w}px;
        ` : null};

        ${({ isProjectPage }) => isProjectPage ? css`
            max-height: 594px;
            height: 594px;
            min-height: 594px;
        ` : null};
    }
    @media(max-width: ${LayoutConst.screen.l}px) {
        ${({ isProjectPage }) => isProjectPage ? css`
            max-height: 100%;
            height: auto;
        ` : null};
    }

    @media (max-width: 743px) {
        border: none;
        flex-direction: column;
        width: 100%;
        padding: 0 10px;
        min-height: 0;

        ${({ isBookMainPage}) => isBookMainPage ? css`
            min-width: auto;
    ` : null};
    }

    ${({ isProjectEdit, isProjectPage, isCompetitionEdit, isBookMainPage, isBookEdit}) => (isProjectEdit || isProjectPage || isCompetitionEdit || isBookMainPage || isBookEdit) ? css`
        @media (max-width: ${LayoutConst.screen.md}px) {
            min-width: 269px;
            margin-top: ${isProjectPage ? '8px' : 0};
            padding-right: ${(isProjectEdit || isBookEdit) ? "10px" : ""};
            max-height: ${(isProjectEdit || isCompetitionEdit || isBookEdit)? 'none' : 'calc((50vw - 24px) * 1.407)'};
            min-height: calc((50vw - 24px) * 1.407);
          
          

/*          min-width: calc(50vw - 24px);
          width: calc(50vw - 24px);
          max-width: calc(50vw - 24px);
          height: calc((50vw - 24px) * 1.407);
          max-height: calc((50vw - 24px) * 1.407);
          min-height:calc((50vw - 24px) * 1.407);*/
        }

/*        @media (max-width: 834px) {
            min-width: 269px;
            max-width: calc(50vw - 8px);
            // margin-top: 8px;
            padding-right: ${isProjectEdit ? "10px" : ""};
            max-height: ${(isProjectEdit || isBookEdit || isCompetitionEdit) ? "none" : LayoutConst.projectCover.s.h + 'px'};
            min-height: ${LayoutConst.projectCover.s.h + 'px'};

        }*/

         @media (max-width: ${LayoutConst.screen.s - 1}px) {
           width: 100%;
           padding-right: 10px;
           max-width: none;
           min-height: auto;
        }
    
    ` : null};

//   ${({ isCompetitionEdit}) => (isCompetitionEdit) ? css`
//         @media(max-width: ${LayoutConst.screen.md}px) {
//             padding: 0;
//             margin: 0;
//             width: calc(50vw - 24px);
//             min-width: calc(50vw - 24px);
//         }
//         @media(max-width: ${LayoutConst.screen.s}px) {
//             padding: 0;
//             margin: 0;
//             width: 100%;
//         }
//     ` : null};
`;

export const ProjectContainerLayoutWrapper = styled(FlexBox)<{
    isProjectEdit?: boolean,
    isProjectPage?: boolean,
    isBookMainPage?: boolean,
    isBookEdit?: boolean,
    isCompetitionEdit?: boolean,
    skipReducedVersion?: boolean,
    isBooks?: boolean,
}>`
    width: 100%;
    justify-content: space-between;

    ${({ isProjectEdit, isCompetitionEdit, isProjectPage, isBookMainPage, isBooks}) =>  (isCompetitionEdit || isProjectEdit || isProjectPage || isBookMainPage) ? css`
        @media(max-width: ${LayoutConst.screen.l}px) {
            align-items: stretch;
        }
        @media(max-width: 940px) {
            flex-direction: row;
            margin-bottom: ${isProjectPage && !isBooks  ? '16px' : '0'};
            margin-left: 16px;
            margin-right: 16px;
            width: calc(100% - 32px);
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            flex-direction: column !important;
            margin-bottom: 0;
            width: 100%;
            margin-left: 0;
            margin-right: 0;
        }
    ` : null };
  
    ${({ isCompetitionEdit}) => (isCompetitionEdit) ? css`
        @media(max-width: ${LayoutConst.screen.md}px) {
            margin: 10px 16px 0;
          width: calc(100% - 32px);
          column-gap: 16px;
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            margin: 0;
            width: 100%;
        }
    ` : null};
  
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-direction: column !important;
        margin-bottom: 0;
    }
`;

export const ProjectContainerLayoutWrapperOuter = styled(FlexBox)<{
    isBookMainPage?: boolean,
    isBookEdit?: boolean,
    isProjectEdit?: boolean,
    isCompetitionEdit?: boolean,
    skipReducedVersion?: boolean,
}>`
    width: 100%;
    max-width: ${LayoutConst.projectContainer.l}px;
    margin: 0 auto;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: ${LayoutConst.projectContainer.m}px;    
    }
  
    ${({isCompetitionEdit}) => (isCompetitionEdit) && css`
      @media (max-width: ${LayoutConst.screen.md}px) {
        max-width: 100%;
      }
    `}
    
    ${({ isBookMainPage, isBookEdit }) =>  isBookMainPage ? css`
        @media (max-width: ${LayoutConst.screen.l_12}px) {
            max-width: ${LayoutConst.projectContainer.m}px; 
            margin: 0 auto;  
        }

        @media(max-width: ${LayoutConst.screen.m}px) {
            margin: 0 auto;   
        }
        @media(max-width: 834px) {
            max-width: 760px;
        }
    ` : null};

    @media (max-width: 940px) {
        flex-direction: column;
        min-height: 0;
        max-height: 100%;
        margin: 0;
    }

  ${({isProjectEdit}) => (isProjectEdit) && css`
    @media (max-width: 940px) {
      margin-bottom: 16px;
    }
    @media (max-width: 744px) {
      margin-bottom: 0px;
    }
    `}
`;



import styled, { css } from 'styled-components';
import { FlexBox } from '@brg/ui';
import { LayoutConst } from 'core/modules';

export const ProjectContainerLayoutLeftWrapper = styled(FlexBox)<{ isCompetitionEdit?: boolean, isAgeytomesh?: boolean, isProjectEdit?: boolean, isProjectPage?: boolean, isBooksPage?: boolean, isBookMainPage?: boolean, isBookEdit?: boolean }>`
    margin-right: 24px;
    height: max-content;
    @media (max-width: 940px) {
        flex-direction: column;
        width: 100%;
        min-height: 0;
        overflow: hidden;
        margin-top: 16px;
        //padding: 0 0 0 min(calc(940px - 100vw)/2 , 10px);
        padding: 0;
        ${({ isAgeytomesh}) => isAgeytomesh ? css`
            margin-top: 0;
        ` : null}
    }
    @media (max-width: 743px) {
        padding: 0 0 0 min(calc(940px - 100vw)/2 , 10px);
    }

    ${({ isProjectEdit, isProjectPage, isBookMainPage, isBookEdit, isCompetitionEdit}) => (isProjectEdit || isProjectPage || isBookMainPage || isBookEdit || isCompetitionEdit) ? css`
       @media(max-width: ${LayoutConst.screen.md}px) {
 /*           max-width: ${LayoutConst.projectCover.m.w}px;
            height: ${LayoutConst.projectCover.m.h}px;
            max-height: ${LayoutConst.projectCover.m.h}px;
            min-height: ${LayoutConst.projectCover.m.h}px;*/
            margin-top: ${isProjectPage ? '8px'  : 'inherit'};
            margin-right: ${isCompetitionEdit ? 0 : '16px'};
            min-width: calc(50vw - 24px);
            width: calc(50vw - 24px);
            max-width: calc(50vw - 24px);
            height: auto;
            min-height: auto;

            > div {
                max-height: calc((50vw - 24px) * 1.407);
            }
        }

        > div {
            @media(max-width: ${LayoutConst.screen.s-1}px) {
                max-height: 100%;
                height: 100%;
                min-height: 100%;
            }
        }
/*
        @media(max-width: 834px) {
            max-width: calc(50vw - 8px);
            height: ${LayoutConst.projectCover.s.h}px;
            max-height: ${LayoutConst.projectCover.s.h}px;
            min-height: ${LayoutConst.projectCover.s.h}px;
            margin-right: 16px;
            margin-top: ${isProjectPage ? '8px' : 'inherit'};
        }
*/

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            flex-direction: column;
            width: 100%;
            max-width: 100%;
            min-width: 100%;
            min-height: 0;
            height: ${isBookEdit ? 'calc((100vw - 10px) * 1.407)' : '100%'};
            max-height: calc((100vw - 10px ${isBookMainPage ? '+ 70px' : ''}) * 1.407);
            overflow: hidden;
            margin-top: ${isProjectEdit || isCompetitionEdit ? 'inherit' : '16px'};
            margin-left: 0;
            padding: 0 min(calc(940px - 100vw)/2 , 10px);
            //padding: 0;
        }
    ` : null};
  
`;
export const ProjectContainerLayoutRightWrapper = styled(FlexBox)<{ isCompetitionEdit?: boolean, isProjectEdit?: boolean, isProjectPage?: boolean, isBookMainPage?: boolean, isBookEdit?: boolean }>`
    width: 100%;

    ${({ isBookMainPage, isProjectPage, isProjectEdit, isCompetitionEdit}) => isCompetitionEdit || isBookMainPage || isProjectPage || isProjectEdit ? css`
        min-width: ${LayoutConst.projectCover.l.w}px;
        max-width: ${LayoutConst.projectCover.l.w}px;
    ` : null};
    

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        ${({ isBookMainPage, isProjectPage, isProjectEdit, isCompetitionEdit, isBookEdit }) => isCompetitionEdit || isBookMainPage || isProjectPage || isProjectEdit || isBookEdit? css`
        max-width: ${LayoutConst.projectCover.m.w}px;
        min-width: ${LayoutConst.projectCover.m.w}px;
    ` : null};
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        ${({ isBookMainPage, isProjectPage, isProjectEdit, isCompetitionEdit, isBookEdit }) => (isCompetitionEdit || isBookMainPage || isProjectPage || isProjectEdit || isBookEdit) ? css`
        min-width: ${LayoutConst.projectCover.m.w}px;
        max-width: ${LayoutConst.projectCover.m.w}px;
        ` : null};

        ${({ isProjectPage }) => isProjectPage ? css`
            max-height: 594px;
            height: 594px;
            min-height: 594px;
        ` : null};
    }
    @media(max-width: ${LayoutConst.screen.l}px) {
        ${({ isProjectPage }) => isProjectPage ? css`
            max-height: 100%;
            height: auto;
        ` : null};
    }

    @media (max-width: 743px) {
        border: none;
        flex-direction: column;
        width: 100%;
        padding: 0 10px;
        min-height: 0;

        ${({ isBookMainPage}) => isBookMainPage ? css`
            min-width: auto;
    ` : null};
    }

    ${({ isProjectEdit, isProjectPage, isCompetitionEdit, isBookMainPage, isBookEdit}) => (isProjectEdit || isProjectPage || isCompetitionEdit || isBookMainPage || isBookEdit) ? css`
        @media (max-width: ${LayoutConst.screen.md}px) {
            min-width: 269px;
            margin-top: ${isProjectPage ? '8px' : 0};
            padding-right: ${(isProjectEdit || isBookEdit) ? "10px" : ""};
            max-height: ${(isProjectEdit || isCompetitionEdit || isBookEdit)? 'none' : 'calc((50vw - 24px) * 1.407)'};
            min-height: calc((50vw - 24px) * 1.407);
          
          

/*          min-width: calc(50vw - 24px);
          width: calc(50vw - 24px);
          max-width: calc(50vw - 24px);
          height: calc((50vw - 24px) * 1.407);
          max-height: calc((50vw - 24px) * 1.407);
          min-height:calc((50vw - 24px) * 1.407);*/
        }

/*        @media (max-width: 834px) {
            min-width: 269px;
            max-width: calc(50vw - 8px);
            // margin-top: 8px;
            padding-right: ${isProjectEdit ? "10px" : ""};
            max-height: ${(isProjectEdit || isBookEdit || isCompetitionEdit) ? "none" : LayoutConst.projectCover.s.h + 'px'};
            min-height: ${LayoutConst.projectCover.s.h + 'px'};

        }*/

         @media (max-width: ${LayoutConst.screen.s - 1}px) {
           width: 100%;
           padding-right: 10px;
           max-width: none;
           min-height: auto;
        }
    
    ` : null};

//   ${({ isCompetitionEdit}) => (isCompetitionEdit) ? css`
//         @media(max-width: ${LayoutConst.screen.md}px) {
//             padding: 0;
//             margin: 0;
//             width: calc(50vw - 24px);
//             min-width: calc(50vw - 24px);
//         }
//         @media(max-width: ${LayoutConst.screen.s}px) {
//             padding: 0;
//             margin: 0;
//             width: 100%;
//         }
//     ` : null};
`;

export const ProjectContainerLayoutWrapper = styled(FlexBox)<{
    isProjectEdit?: boolean,
    isProjectPage?: boolean,
    isBookMainPage?: boolean,
    isBookEdit?: boolean,
    isCompetitionEdit?: boolean,
    skipReducedVersion?: boolean,
    isBooks?: boolean,
}>`
    width: 100%;
    justify-content: space-between;

    ${({ isProjectEdit, isCompetitionEdit, isProjectPage, isBookMainPage, isBooks}) =>  (isCompetitionEdit || isProjectEdit || isProjectPage || isBookMainPage) ? css`
        @media(max-width: ${LayoutConst.screen.l}px) {
            align-items: stretch;
        }
        @media(max-width: 940px) {
            flex-direction: row;
            margin-bottom: ${isProjectPage && !isBooks  ? '16px' : '0'};
            margin-left: 16px;
            margin-right: 16px;
            width: calc(100% - 32px);
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            flex-direction: column !important;
            margin-bottom: 0;
            width: 100%;
            margin-left: 0;
            margin-right: 0;
        }
    ` : null };
  
    ${({ isCompetitionEdit}) => (isCompetitionEdit) ? css`
        @media(max-width: ${LayoutConst.screen.md}px) {
            margin: 10px 16px 0;
          width: calc(100% - 32px);
          column-gap: 16px;
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            margin: 0;
            width: 100%;
        }
    ` : null};
  
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-direction: column !important;
        margin-bottom: 0;
    }
`;

export const ProjectContainerLayoutWrapperOuter = styled(FlexBox)<{
    isBookMainPage?: boolean,
    isBookEdit?: boolean,
    isProjectEdit?: boolean,
    isCompetitionEdit?: boolean,
    skipReducedVersion?: boolean,
}>`
    width: 100%;
    max-width: ${LayoutConst.projectContainer.l}px;
    margin: 0 auto;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: ${LayoutConst.projectContainer.m}px;    
    }
  
    ${({isCompetitionEdit}) => (isCompetitionEdit) && css`
      @media (max-width: ${LayoutConst.screen.md}px) {
        max-width: 100%;
      }
    `}
    
    ${({ isBookMainPage, isBookEdit }) =>  isBookMainPage ? css`
        @media (max-width: ${LayoutConst.screen.l_12}px) {
            max-width: ${LayoutConst.projectContainer.m}px; 
            margin: 0 auto;  
        }

        @media(max-width: ${LayoutConst.screen.m}px) {
            margin: 0 auto;   
        }
        @media(max-width: 834px) {
            max-width: 760px;
        }
    ` : null};

    @media (max-width: 940px) {
        flex-direction: column;
        min-height: 0;
        max-height: 100%;
        margin: 0;
    }

  ${({isProjectEdit}) => (isProjectEdit) && css`
    @media (max-width: 940px) {
      margin-bottom: 16px;
    }
    @media (max-width: 744px) {
      margin-bottom: 0px;
    }
    `}
`;

